import { forwardRef, useEffect, useRef, useState } from "react";
import { Marker, Popup } from "react-leaflet";
import { decodeString } from "../../../utils/string";

const CustomMarker = forwardRef(
  (
    {
      entity,
      MarkerIcon,
      setSelectedInstitution,
      scrollbarInstance,
      lineRefs,
      i,
      colorsArray,
      innerIcon,
      popupRefs,
      filtersKeys,
      sizeState,
    },
    ref
  ) => {
    return (
      <Marker
        icon={MarkerIcon}
        key={entity.id}
        position={[entity.latitude, entity.longitude]}
        calc={entity}
        eventHandlers={{
          click: (e) => {
            e.target.refreshIconOptions(null, true);
            setSelectedInstitution(entity);
            if (process.env.REACT_APP_SIDEBAR !== "none") {
              const { viewport } = scrollbarInstance.elements();
              viewport.scrollTo({
                top: lineRefs.current[i].current.offsetTop,
                behavior: "smooth",
              });
            }
          },
        }}
        ref={ref}
      >
        {process.env.REACT_APP_POPUP === "true" && (
          <Popup
            options={entity}
            ref={popupRefs.current[i]}
            autoPanPaddingTopLeft={[50, 50]}
            autoPanPaddingBottomRight={[50, 50]}
            className="my-marker-popup"
          >
            <div className="gl-popup monappart">
              <a className="button" key={entity.id} ref={ref} href={entity.url}>
                <div className={`name`}>{decodeString(entity.name)}</div>
              </a>
            </div>
          </Popup>
        )}
      </Marker>
    );
  }
);
export default CustomMarker;
